import { toast } from "react-toastify";

export const forgotPassword = async (internalApi, email) => {
	return internalApi.post("common/forgot-password", { email }).then(() => {
		toast.success(
			"Password reset link has been sent to your email. Please check your junk mail and promotions.",
		);
		return Promise.resolve();
	});
};
